import { FC, MouseEventHandler } from 'external/react'

type SupportRequestButtonProps = {
	onClick: MouseEventHandler<HTMLButtonElement>
}

const SupportRequestButton: FC<SupportRequestButtonProps> = props => {
	const {onClick} = props
    return (
        <button className='btn btn-primary mt-2 w-100' onClick={onClick} >
            Enviar
        </button>
    )
}

export default SupportRequestButton
